import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Prismic from 'prismic-javascript';
import styled from 'styled-components';
import { RichText } from 'prismic-reactjs';

import LanguageContext from '../../context/LangContext';

import Box from './box';

const Container = styled.div`
  margin-bottom: 100px;
`

const Title = styled.strong`
  font: italic bold 40px 'Times new roman';
`

class Faq extends Component {
  state = {
    faq: [],
    language: ''
  }

  componentDidMount = () => {
    const { language } = this.context;
    this.setState({language: language});
    this.getContent();
  }

  componentDidUpdate = () => {
    const { language } = this.context;
    if (language !== this.state.language) {
      this.getContent();
      this.setState({language: language});
    }
  }

  getContent = () => {
    const { language } = this.context;
    const apiEndpoint = 'https://guararapes.cdn.prismic.io/api/v2'
    const Client = Prismic.client(apiEndpoint);

    const fetchData = async () => {
      const response = await Client.query(
        Prismic.Predicates.at('document.type', 'faq'),
        {lang: language}
      )
      if (response) {
        response.results.map((item) => item.data.ordem = item.data.ordem?item.data.ordem:99 )
        response.results.sort((a, b) => { return a.data.ordem - b.data.ordem; })
        this.setState({faq: response.results});
      }
    }
    fetchData();
  }

  render () {
    const { language } = this.context;
    let title = '';
    switch(language) {
      case 'pt-br':
        title = 'Dúvidas Frequentes'
        break;
      case 'en-us':
        title = 'FAQ'
        break;
      case 'es-es':
        title = 'Preguntas frecuentes'
        break;
      default:
    }
    return (
      <Container>
        <Title>{ title }</Title>
        {
          this.state.faq && this.state.faq.map((item, index) => {
            return (
              <Box key={ index } title={ item.data.titulo[0].text }>
                { RichText.render(item.data.texto) }
              </Box>
            )
          })
        }
      </Container>
    )
  }
}

Faq.propTypes = {
  dispatch: PropTypes.func,
  match: PropTypes.object,
  location: PropTypes.object,
  context: PropTypes.object,
};

Faq.contextType = LanguageContext;

export default Faq;
